import React from "react";
import Box from "../layout/Box";
import FileInput from "../form/FileInput";
import {fileUpload} from "../../utils/request";
import classNames from "classnames";
import parse_str from "locutus/php/strings/parse_str";
import {showModal} from "../../actions";
import {connect} from "react-redux";
import Button from "../form/Button";

class StoreOrderImport extends React.Component {

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    state = {
        isLoading: false
    }

    importFile = async (field, value) => {
        await this.promisedSetState({isLoading: true});
        try {
            const response = await fileUpload({action: "storeorder.import", [field]: value});
            if(response.success) {
                if(response.redirect) {
                    let params = {};
                    parse_str(response.redirect.substr(1), params);
                    this.props.setContent(params.option, params);
                }
            } else {
                this.showModal({theme: "danger", header: "hiba", text: response});
                console.error(response);
            }
        } catch (e) {
            console.error(e);
        }
        await this.promisedSetState({isLoading: false});
    }

    render () {
        // $_FILES["import"]
        return (
            <Box theme={"primary"}>
                <FileInput name="file" disabled={this.state.isLoading} saveChanges={this.importFile}><Button color="primary" disabled={this.state.isLoading}>Import</Button></FileInput>
            </Box>
        );
    }

}

export default connect(() => ({}), {showModal})(StoreOrderImport);